export class ScreenCrud {
  static ALL = "A";
  static CREATE_READ_UPDATE = "CRU";
  static READ = "R";
  constructor(value) {
    this.value = value;
  }
  isOperation() {
    return (
      this.value === ScreenCrud.ALL ||
      this.value === ScreenCrud.CREATE_READ_UPDATE
    );
  }
  isRead() {
    return this.value === ScreenCrud.READ;
  }
  isAll() {
    return this.value === ScreenCrud.ALL;
  }
  static factory(value) {
    return new ScreenCrud(value);
  }
}
